import api from './api';
import { LoginRequest, LoginResponse, User } from '../types';

class AuthService {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await api.post('/auth/login', credentials);
    const { data } = response.data;

    if (data.token) {
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
    }

    return data;
  }

  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  getCurrentUser(): User | null {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    try {
      return JSON.parse(userStr) as User;
    } catch {
      localStorage.removeItem('user');
      return null;
    }
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  async changePassword(
    currentPassword: string,
    newPassword: string
  ): Promise<void> {
    await api.put('/auth/change-password', {
      currentPassword,
      newPassword,
    });
  }

  async refreshProfile(): Promise<User> {
    const response = await api.get('/auth/profile');
    const user = response.data.data as User;
    localStorage.setItem('user', JSON.stringify(user));
    return user;
  }

  /** Validate stored token against API; clears storage if invalid */
  async validateSession(): Promise<User | null> {
    if (!this.getToken()) {
      return null;
    }
    try {
      return await this.refreshProfile();
    } catch {
      this.logout();
      return null;
    }
  }
}

const authService = new AuthService();
export default authService;
